// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wXe-","newExpiryDate":"styles_newExpiryDate__Z2yuJ","footer":"styles_footer__3MM37"};